<template>
  <v-navigation-drawer
    app
    permanent
    clipped
    fixed
    transition="slide-y-reverse-transition"
    v-if="show && config.tags"
  >
    <v-list-item two-line>
      <v-list-item-avatar class="grey lighten-3">
        <v-img
          cover
          v-if="user && user.photoURL"
          :src="$connection + user.photoURL"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0 grey lighten-2"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row> </template
        ></v-img>
        <v-icon v-else>mdi-account</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ user.fullname }}</v-list-item-title>
        <v-list-item-subtitle
          :class="isLoggedIn ? 'teal--text' : 'red--text'"
          >{{
            isLoggedIn ? "Logged In" : "Not logged in"
          }}</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense nav>
      <v-list-item
        v-for="(val, key, index) in items"
        :key="index"
        v-show="showSide(key)"
        :to="{ name: val.title }"
        :class="val.title !== $route.name ? 'active' : ''"
        link
      >
        <v-list-item-icon>
          <v-icon :color="config.icons[key].color">{{
            config.icons[key].icon
          }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t(val.translation) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-show="showSide('publish')"
        :to="{ name: 'Publish' }"
        :class="'Publish' !== $route.name ? 'active' : ''"
        link
      >
        <v-list-item-icon>
          <v-icon :color="config.icons['publish'].color">{{
            config.icons["publish"].icon
          }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("nav.publish") }}</v-list-item-title>
        </v-list-item-content>
      <v-badge v-show="requests.length > 0" color="info" class="mr-2" :content="requests.length.toString()"></v-badge>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <template v-slot:append>
      <v-list dense nav>
        <v-list-item @click="logout" class="grey--text text--darken-1" link>
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title> Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      items: {
        dashboard: {
          translation: "nav.dashboard",
          title: "Dashboard",
        },
        department: {
          translation: "nav.departments",
          title: "Account_Department",
        },
        course: {
          translation: "nav.courses",
          title: "Account_Course",
        },
        workshop: {
          translation: "nav.workshops",
          title: "Account_Workshop",
        },
        blog: {
          translation: "nav.blog",
          title: "Account_Post",
        },
        news: {
          translation: "nav.news",
          title: "News",
        },
        location: {
          translation: "nav.locations",
          title: "AccountLocations",
        },
        // support: {
        //   translation: "nav.support",
        //   title: "Support",
        // },
        sponsor: {
          translation: "nav.sponsor",
          title: "Sponsors",
        },
        profile: {
          translation: "nav.profile",
          title: "Profile",
        },
      },
    };
  },
  computed: {
    show() {
      return ~this.$route.fullPath.indexOf("account");
    },
    user() {
      return this.$store.getters["user/getUser"];
    },
    isLoggedIn() {
      return this.$store.getters["user/getLoggedIn"];
    },
    config() {
      return this.$store.getters["config/getConfig"];
    },
    requests() {
      return this.$store.getters["user/getRequests"];
    },
  },
  methods: {
    showSide(key) {
      let show = true;
      switch (key) {
        case "dashboard":
          show = Array.of("admin", "owner", "department").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "department":
          show = Array.of("admin", "owner", "department").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "course":
          show = Array.of("course", "admin", "owner", "department").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "workshop":
          show = Array.of("workshop", "admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "blog":
          show = Array.of(
            "course",
            "department",
            "workshop",
            "admin",
            "owner"
          ).some((x) => this.user.roles.includes(x));
          break;
        case "news":
          show = Array.of(
            "course",
            "department",
            "workshop",
            "admin",
            "owner"
          ).some((x) => this.user.roles.includes(x));
          break;
        case "banners":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "support":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "sponsor":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "location":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "publish":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        default:
          break;
      }
      return show;
    },
    logout() {
      this.$store.dispatch("user/logout");
    },
  },
};
</script>

<style>
</style>